import { API } from "@/services"

export const USER_ENDPOINTS = {
  findById(id='',params={}){
    return API.Axios.error_capture.v1.request({
      url: `users/${id}`,
      method: 'GET',
      params,
    })
  },
}